"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TaxonomyTerms = /** @class */ (function () {
    function TaxonomyTerms(data) {
        Object.assign(this, data);
    }
    return TaxonomyTerms;
}());
exports.TaxonomyTerms = TaxonomyTerms;
//# sourceMappingURL=taxonomy-terms.class.js.map